import React from 'react';
import { Award } from 'lucide-react';
import { Heart } from 'lucide-react';
import { ShieldCheck } from 'lucide-react';
import { Text } from '../components/Text';
import NavBar from "../components/navigation";
import Footer from "../components/Footer";


export const AboutPage = ({ className, children, variant, contentKey, ...props }) => {
  return (
 <>
    <NavBar />
    <div className="text-text">
      
        
        {/* Driven By Excellence */}
        <section id="driven_by_excellence" className="relative pt-32 pb-20 bg-gradient-to-br from-dark to-primary overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1486496146582-9ffcd0b2b2b7?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center"></div>
          <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10 text-center">
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-white mb-6"> Driven by Excellence </h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
               For over 15 years, My Car has redefined the luxury automotive experience with integrity, expertise, and an unwavering commitment to our clients. 
            </p>
          </div>
        </section>
        {/* Connecting Drivers With Their Perfect Vehicle */}
        <section id="connecting_drivers_with_their_perfect_vehicle" className="py-24 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <div className="inline-block mb-6">
                  <Text variant="bold" className="px-5 py-2 bg-primary/10 text-primary text-sm font-bold uppercase tracking-wider rounded-full"> Our Mission </Text>
                </div>
                <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark mb-6"> Connecting Drivers with Their Perfect Vehicle </h2>
                <p className="text-lg text-muted leading-relaxed mb-6">
                   At My Car, we believe car buying should be exciting, transparent, and stress-free. We've built our reputation on delivering premium vehicles paired with exceptional service that exceeds expectations every single time. 
                </p>
                <p className="text-lg text-muted leading-relaxed">
                   Our team of automotive experts is passionate about helping you find not just a car, but the right car—one that fits your lifestyle, budget, and dreams. 
                </p>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div className="glass-card rounded-3xl p-8 text-center">
                  <div className="text-5xl font-heading font-bold text-primary mb-2"> 15+ </div>
                  <div className="text-muted font-medium"> Years in Business </div>
                </div>
                <div className="glass-card rounded-3xl p-8 text-center">
                  <div className="text-5xl font-heading font-bold text-primary mb-2"> 500+ </div>
                  <div className="text-muted font-medium"> Vehicles in Stock </div>
                </div>
                <div className="glass-card rounded-3xl p-8 text-center">
                  <div className="text-5xl font-heading font-bold text-primary mb-2"> 10K+ </div>
                  <div className="text-muted font-medium"> Happy Customers </div>
                </div>
                <div className="glass-card rounded-3xl p-8 text-center">
                  <div className="text-5xl font-heading font-bold text-primary mb-2"> 98% </div>
                  <div className="text-muted font-medium"> Satisfaction Rate </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Our Core Values */}
        <section id="our_core_values" className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-dark mb-6"> Our Core Values </h2>
              <p className="text-xl text-muted max-w-3xl mx-auto"> The principles that guide everything we do </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><ShieldCheck className="w-10 h-10 " /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Integrity First </h3>
                <p className="text-muted leading-relaxed">
                   Transparent pricing, honest assessments, and ethical practices in every transaction. Your trust is our most valuable asset. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><Award className="w-10 h-10 " /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Quality Obsessed </h3>
                <p className="text-muted leading-relaxed">
                   Every vehicle meets our rigorous 150-point certification. We never compromise on quality or safety standards. 
                </p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary to-accent rounded-full flex items-center justify-center mx-auto mb-6"><Heart className="w-10 h-10" /></div>
                <h3 className="text-2xl font-heading font-bold text-dark mb-4"> Client-Centric </h3>
                <p className="text-muted leading-relaxed">
                   Your satisfaction drives our success. We listen, advise, and deliver experiences that exceed expectations. 
                </p>
              </div>
            </div>
          </div>
        </section>
      
    </div>
    <Footer />
    </>
  );
};